import React, { useEffect } from 'react';
import { CloseIcon } from 'components/icons';
import styles from './modal.module.scss';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: React.ReactNode;
  customHeader?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  headerClassName?: string;
  hideCloseButton?: boolean;
  closeOnOverlayClick?: boolean;
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  title,
  customHeader,
  children,
  className,
  headerClassName,
  hideCloseButton,
  closeOnOverlayClick = true,
}) => {
  // Prevent background scrolling when open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = 'var(--scrollbar-width, 0px)';
    } else {
      // Check if any other modals are still open before re-enabling scroll
      const otherModals = document.querySelectorAll('[class*="modalOverlay"]');
      if (otherModals.length <= 1) {
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
      }
    }

    return () => {
      const otherModals = document.querySelectorAll('[class*="modalOverlay"]');
      if (otherModals.length <= 1) {
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
      }
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className={styles.modalOverlay}
      onClick={closeOnOverlayClick ? (hideCloseButton ? undefined : onClose) : undefined}
    >
      <div
        className={`${styles.modalContent} ${className || ''}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={`${styles.modalHeader} ${headerClassName || ''}`}>
          {customHeader ? customHeader : title && <h2 className={styles.modalTitle}>{title}</h2>}
          {!hideCloseButton && (
            <button className={styles.closeBtn} onClick={onClose} aria-label="Close modal">
              <CloseIcon width="24" height="24" />
            </button>
          )}
        </div>
        <div className={styles.modalBody}>{children}</div>
      </div>
    </div>
  );
};

export default Modal;
